import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { isDevMode } from '../utils/constants';
import { ar } from './ar';
import { en } from './en';

i18n.use(initReactI18next).init({
  resources: {
    en,
    ar,
  },
  lng: 'en',
  debug: isDevMode,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
